<template>
  <dy-dialog v-model="visible" width="70%" title="选择客户" confirm-title="确定" :show-confirm="!!selectRow"
    @onConfirm="handleSelected" @onClose="handleClose">
    <el-form :model="params" :inline="true" class="VehicleInformationHeader">
      <el-form-item label="姓名">
        <el-input v-model="params.realName" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="params.phone" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item style="flex-shrink: 0;margin-right: 0px;">
        <el-button type="primary" size="mini" @click="search()">搜索</el-button>
        <el-button size="mini" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="VehicleInformationBody">
      <el-table border :data="tableData" row-key="id" class="tableCustomizeStyle" max-height="462" highlight-current-row
        @current-change="rowClick" @row-click="showRow">
        <el-table-column width="80px">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.userId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column v-for="item in staffColumn" :prop="item.prop" :label="item.label" :key="item.prop"
          min-width="100" />
      </el-table>
      <el-pagination background :current-page="params.pageNum" :page-sizes="[10, 20, 30, 40]"
        :page-size="params.pageSize" layout="total,prev,pager,next,sizes,jumper" :total="total-0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </dy-dialog>
</template>

<script>
import store from "@/store";
import DyDialog from "@/components/DYDialog/index.vue";
import { staffGuardList } from "@/api/passingmgmt/doorAuth.js";

export default {
  name: "DySelectStaffDialog",
  components: { DyDialog },
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
        realName: undefined,
        phone: undefined,
      },
      total: 0,
      tableData: [],
      selectRow: undefined,
      staffColumn: [
        { label: "姓名", prop: "realName" },
        { label: "岗位", prop: "roleName" },
        { label: "手机号", prop: "phone" },
      ],
      visible: false,
      radio: undefined,
    };
  },
  computed: {
    project() {
      return store.getters.project;
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.loading = true;
      this.params.projectCode = this.project.code;
      this.getList();
    },
    getList() {
      this.loading = true;
      staffGuardList(this.params)
        .then((resu) => {
          this.tableData = resu.data?.records || [];
          this.total = parseInt(resu.data?.total || 0);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(i) {
      this.params.pageNum = i;
      this.open();
    },
    handleSizeChange(i) {
      this.params.pageSize = i;
      this.params.pageNum = 1;
      this.open();
    },
    reset() {
      this.params = this.$options.data().params;
      this.getList();
    },
    search() {
      this.params.pageNum = 1;
      this.getList();
    },
    handleSelected() {
      this.visible = false;
      this.$emit("confirm", this.selectRow);
    },
    handleClose() {
      this.visible = false;
    },
    rowClick(row) {
      this.selectRow = row;
    },
    showRow(row){
      this.radio = row.userId
    }
  },
};
</script>

<style scoped lang="scss">
.select-asset-dialog {
  height: 515px;
  overflow: hidden;
}

::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
